import type { ButtonHTMLAttributes, ReactNode } from 'react';

/**
 * Пять видов кнопки кита v2.11: основная, тихая, призрачная, опасная, малая.
 * `ghost` — без фона и контура: действие в строке, «⋯» в строке связи.
 */
type Tone = 'primary' | 'quiet' | 'ghost' | 'danger';

const TONE_CLASS: Record<Tone, string> = {
  primary: 'btn-p',
  quiet: 'btn-q',
  ghost: 'btn-g',
  danger: 'btn-d',
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /**
   * Сплошная графитовая заливка — только у основной кнопки,
   * **одна на экран**: она и должна быть самым тёмным пятном (кит, п. 1).
   */
  tone?: Tone;
  small?: boolean;
  /** Квадратная кнопка-иконка `.btn.ic` — «⋯» и подобные */
  icon?: boolean;
  children: ReactNode;
}

export function Button({ tone = 'quiet', small, icon, className, children, ...rest }: ButtonProps) {
  return (
    <button
      type="button"
      className={['btn', TONE_CLASS[tone], small ? 'btn-s' : '', icon ? 'ic' : '', className ?? '']
        .filter(Boolean)
        .join(' ')}
      {...rest}
    >
      {children}
    </button>
  );
}
